import template_1 from "../../assets/email_template/INQUIRY_POSITION.png";
import template_2 from "../../assets/email_template/ACK_RECEPT_APPLICATION.png";
import template_3 from "../../assets/email_template/CANDIDATE_CONSIDER.png";
import template_4 from "../../assets/email_template/POSISTION_FILL.png";
import template_5 from "../../assets/email_template/POSSIBLE_CONSIDERATION.png";
import template_6 from "../../assets/email_template/REJECT.png";
import { showToast, TOAST_TYPE } from "deskera-ui-library";
import EmailTemplate1 from "./basicEmailTemplates/Template1";
import EmailTemplate2 from "./basicEmailTemplates/Template2";
import EmailTemplate3 from "./basicEmailTemplates/Template3";
import EmailTemplate4 from "./basicEmailTemplates/Template4";

export default class EmailTemplateManager {
    static pageData;
    static selectedTemplate;
    static getEmailTemplates() {
        return [
            // template_1, // note will use later
            template_2,
            template_3,
            template_4
        ]
    }
    static setSelectedTemplate(template) {
        EmailTemplateManager.selectedTemplate = template;
    }
    static setPageData(pageData) {
        EmailTemplateManager.pageData = pageData;
    }
    static getPageData() {
        return EmailTemplateManager.pageData;
    }
    static getSelectedTemplate() {
        return EmailTemplateManager.selectedTemplate;
    }
    static getSelectedTemplateId() {
        return EmailTemplateManager.selectedTemplateId;
    }
    static getDefaultEmailTemplate(index) {
        switch (index) {
            case 0:
                return EmailTemplate2.getTemplate();
            case 1:
                return EmailTemplate3.getTemplate();
            case 2:
                return EmailTemplate4.getTemplate();
            // case 3: // note will use later
            //     return EmailTemplate4.getTemplate();
            default:
                return EmailTemplate2.getTemplate();

        }
    }
    static getDefaultEmailTemplateName(index) {
        switch (index) {
            case 0:
                return EmailTemplate2.getTemplateName();
            case 1:
                return EmailTemplate3.getTemplateName();
            case 2:
                return EmailTemplate4.getTemplateName();
            // case 3: // note will use later
            //     return EmailTemplate4.getTemplateName();
            default:
                return EmailTemplate2.getTemplateName();

        }
    }
}